import React from "react";
type PagePreviewSlotProps = {
  src?: string;
  label: string;
  detail: string;
};

// Interior page slot — shows a neutral page skeleton until a real screenshot is added.
export function PagePreviewSlot({
  src,
  label,
  detail
}: PagePreviewSlotProps) {
  if (src) {
    return <figure className="overflow-hidden rounded-2xl bg-white shadow-[0_12px_28px_-14px_rgba(11,24,56,0.35)] ring-1 ring-ink/5" data-id="element-196" data-mp="1jwamfsju8k98">
        <img src={src} alt={`${label} — ${detail}`} loading="lazy" className="aspect-[4/5] w-full object-cover object-top" data-id="element-197" data-mp="m9v5crvbpom7" />
      </figure>;
  }
  return <figure aria-label={`${label} preview for ${detail} — screenshot coming soon`} className="flex aspect-[4/5] flex-col rounded-2xl bg-white p-3 shadow-[0_12px_28px_-14px_rgba(11,24,56,0.3)] ring-1 ring-ink/5 md:p-4" data-id="element-198" data-mp="r5si6o7docu8">
      <div aria-hidden="true" className="flex flex-1 flex-col gap-2" data-id="element-199" data-mp="3ikgshd2lnxh">
        <span className="mx-auto h-3 w-2/3 rounded-full bg-royal-light" data-id="element-200" data-mp="3g82ce6itvp6" />
        <span className="mx-auto h-5 w-1/2 rounded-md bg-gold-light" data-id="element-201" data-mp="8g44e7vnrd23" />
        <div className="mt-1 grid flex-1 grid-cols-2 gap-2" data-id="element-202" data-mp="13on4r66gckvo">
          <span className="rounded-lg border-2 border-dashed border-royal-soft" data-id="element-203" data-mp="13py66zcfdgjm" />
          <span className="rounded-lg border-2 border-dashed border-royal-soft" data-id="element-204" data-mp="ypsjlxl0ik8e" />
          <span className="col-span-2 rounded-lg border-2 border-dashed border-royal-soft" data-id="element-205" data-mp="twzdp6dt55uq" />
        </div>
      </div>
      <figcaption className="mt-2 rounded-xl bg-canvas px-2 py-2 text-center" data-id="element-206" data-mp="oyxoe3psgaat">
        <span className="block font-display text-[10px] font-extrabold uppercase tracking-wider text-royal md:text-[11px]" data-id="element-207" data-mp="kydpaulnmwm1">
          {label}
        </span>
        <span className="mt-0.5 block text-[11px] leading-snug text-ink-soft md:text-xs" data-id="element-208" data-mp="az6by7ex71yx">{detail}</span>
      </figcaption>
    </figure>;
}